import React, { useEffect, useState } from "react";
import config from "../../config";
import { useHistory } from "react-router-dom";

// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Modal from "../modals/Modal";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TextField,
    Grid,
    CircularProgress,
    Select,
    FormControl,
    MenuItem
} from "@material-ui/core";
import Widget from "../../components/Widget/Widget";
import ModalLoading from "../../pages/modals/ModalLoading";
import Divider from "./component/divider";
import ModalMessageGeneric from "../modals/ModalMessageGeneric";
import SnackbarMessage from "../modals/SnackbarMessage";

export default function CashOut() {
    const classes = useStyles();

    //global
    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [allCasher, setAllCasher] = useState([]);
    const [casher, setCasher] = useState({ id: '', name: '', valid: null });
    const [sales, setSales] = useState([]);
    const [salesAdditional, setSalesAdditional] = useState([]);
    const [entry, setEntry] = useState([]);
    const [egress, setEgress] = useState([]);
    const [purchase, setPurchase] = useState([]);
    const [salesTotal, setSalesTotal] = useState(0);
    const [salesAdditionalTotal, setSalesAdditionalTotal] = useState(0);
    const [entryTotal, setEntryTotal] = useState(0);
    const [egressTotal, setEgressTotal] = useState(0);
    const [purchaseTotal, setPurchaseTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [reportCash, setReportCash] = useState(0);
    const [totalCash, setTotalCash] = useState(0);
    const [totalVoucher, setTotalVoucher] = useState(0);
    const [totalCommission, setTotalCommission] = useState(0);
    const [totalTransfer, setTotalTransfer] = useState(0);
    const [difference, setDifference] = useState(0);
    const [turn, setTurn] = useState('');
    const [currentTime, setCurrentTime] = useState('');
    const [entryId, setEntryId] = useState([]);
    const [egressId, setEgressId] = useState([]);

    const [keyTableSales, setKeyTableSales] = useState(1);
    const [keyTableSalesAdditional, setKeyTableSalesAdditional] = useState(1);
    const [keyTableEntry, setKeyTableEntry] = useState(1);
    const [keyTableEgress, setKeyTableEgress] = useState(1);
    const [keyTotal, setKeyTotal] = useState(1);
    const [showModalLoading, setShowModalLoading] = useState(false);
    const [today, setToday] = useState(null);
    const [showModalMessage, setShowModalMessage] = useState(false);

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [messageSnackbar, setMessageSnackbar] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const allTurns = [
        {
            "name": "Matutino",
            "value": 1,
        },
        {
            "name": "Vespertino",
            "value": 2,
        },
        {
            "name": "Medio día",
            "value": 3,
        },
    ];

    const handleToClose = (event, reason) => {
        if ("clickaway" == reason) return;
        setShowSnackbar(false);
    };

    const closeModalLoading = e => {
        setShowModalLoading(false);
    }

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const closeModalMessage = e => {
        setShowModalMessage(false);
    }

    useEffect(() => {
        localStorage.removeItem("salesTotal");
        localStorage.removeItem("otherSalesTotal");
        localStorage.removeItem("entryTotal");
        localStorage.removeItem("egressTotal");
        localStorage.removeItem("reportCash");
        localStorage.removeItem("reportCashId");
        localStorage.removeItem("purchaseTotal");
        localStorage.removeItem("totalCommission");
        localStorage.removeItem("totalTransfer");
        localStorage.removeItem("totalVoucher");
        localStorage.removeItem("totalCash");

        const today = new Date();
        var day = "";
        setCurrentTime(today.getHours() + ':' + today.getMinutes());

        if (today.getDate() < 10) {
            day = '0' + today.getDate();
        } else {
            day = today.getDate();
        }

        if ((today.getMonth() + 1) < 10) {
            setToday(day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear());
        } else {
            setToday(day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear());
        }
        fetchCashers();
    }, []);

    const fetchCashers = async () => {
        fetch(baseUrl + "cashers",
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            }).then(response => response.json())
            .then(data => {
                if (data.error == null) {
                    setAllCasher(data);
                } else {
                    setMessageSnackbar("No se encontraron cajeros");
                    setErrorSnackbar(true);
                    setShowSnackbar(true);
                }
            }).catch(error => null);
    }

    const fetchSales = async (id) => {
        const body = {
            date: today, idUser: id
        };

        fetch(baseUrl + "salesByCasher",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(body)
            }).then(response => response.json())
            .then(data => {
                if (data.error == null) {
                    setSales(data.content);
                    setSalesTotal(data.total);
                    localStorage.setItem("salesTotal", data.total);
                    fetchEntry(id);
                } else {
                    setMessageSnackbar("Error al consultar ventas");
                    setErrorSnackbar(true);
                    setShowSnackbar(true);
                }
            }).catch(error => null);

        setKeyTableSales(keyTableSales + 1);
    }

    const fetchOtherSales = async (value) => {
        const body = {
            date: today, turn: value
        };

        fetch(baseUrl + "otherSalesByTurn",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(body)
            }).then(response => response.json())
            .then(data => {
                if (data.error == null) {
                    setSalesAdditional(data.content);
                    setSalesAdditionalTotal(data.total);
                    localStorage.setItem("otherSalesTotal", data.total);
                    calculateTotal();
                } else {
                    setMessageSnackbar("Error al consultar otras ventas");
                    setErrorSnackbar(true);
                    setShowSnackbar(true);
                }
            }).catch(error => null);

        setKeyTableSales(keyTableSales + 1);
    }

    const fetchEntry = async (id) => {
        if (!showModal) {
            const body = {
                date: today, idUser: id, time: currentTime
            };

            fetch(baseUrl + "entryByCasher",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setEntry(data.content);
                        setEntryTotal(data.total);
                        localStorage.setItem("entryTotal", data.total);
                        var entries = [];
                        data.content.map((item) => {
                            entries.push(item.idEntryToCashOut);
                        });
                        setEntryId(entries);
                        fetchPurchase(id);
                    } else {
                        setMessageSnackbar("Error al consultar ingresos");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);

            setKeyTableEntry(keyTableEntry + 1);
        }
    }

    const fetchPurchase = async (id) => {
        if (!showModal) {
            const body = {
                date: today, idUser: id
            };

            fetch(baseUrl + "purchaseByDate",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setPurchase(data.content);
                        setPurchaseTotal(data.total);
                        localStorage.setItem("purchaseTotal", data.total);
                        fetchEgress(id);
                    } else {
                        setMessageSnackbar("Error al consultar compras");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);

            setKeyTableEgress(keyTableEgress + 1);
        }
    }

    const fetchEgress = async (id) => {
        if (!showModal) {
            const body = {
                date: today, idUser: id, time: currentTime
            };

            fetch(baseUrl + "egressByCasher",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setEgress(data.content);
                        setEgressTotal(data.total);
                        localStorage.setItem("egressTotal", data.total);
                        var egress = [];
                        data.content.map((item) => {
                            egress.push(item.idEntryToCashOut);
                        });
                        setEgressId(egress);
                        fetchReportCash(id);
                    } else {
                        setMessageSnackbar("Error al consultar egresos");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);

            setKeyTableEgress(keyTableEgress + 1);
        }
    }

    const fetchReportCash = async (id) => {
        if (!showModal) {
            const body = {
                date: today, idUser: id
            };

            fetch(baseUrl + "reportCashByCasher",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        if (data.content != "No hay reporte de caja") {
                            setReportCash(data.content.total);
                            setTotalCash(data.content.totalCash);
                            setTotalVoucher(data.content.totalVoucher);
                            setTotalCommission(data.content.totalCommission);
                            setTotalTransfer(data.content.totalTransfer);
                            localStorage.setItem("reportCash", data.content.total);
                            localStorage.setItem("reportCashId", data.content.id);
                            localStorage.setItem("totalCash", data.content.totalCash);
                            localStorage.setItem("totalVoucher", data.content.totalVoucher);
                            localStorage.setItem("totalCommission", data.content.totalCommission);
                            localStorage.setItem("totalTransfer", data.content.totalTransfer);
                            calculateTotal();
                        } else {
                            setMessageSnackbar(data.content);
                            setErrorSnackbar(true);
                            setShowSnackbar(true);
                        }
                    } else {
                        setMessageSnackbar("Error al consultar reporte de caja");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);
        }
    }

    const handleChange = (e) => {
        const value = e.target.value;
        if (value != '') {
            var name = '';

            allCasher.map((option) => {
                if (option.id == value) {
                    name = option.name;
                }
            });

            setCasher({ ...casher, id: value, name: name, valid: 'true' });
        } else {
            setCasher({ ...casher, id: '', name: '', valid: 'false' });
        }
        fetchSales(value);
    }

    const handleChangeTurn = (e) => {
        const value = e.target.value;
        setTurn(value);

        fetchOtherSales(value);
    }

    function calculateTotal() {
        var value = 0;
        var saleTotal = localStorage.getItem("salesTotal");
        var otherSalesTotal = localStorage.getItem("otherSalesTotal");
        var entryTotal = localStorage.getItem("entryTotal");
        var egressTotal = localStorage.getItem("egressTotal");

        var reportCash = localStorage.getItem("reportCash");
        var purchaseTotal = localStorage.getItem("purchaseTotal");
        var totalCommission = localStorage.getItem("totalCommission");
        var totalTransfer = localStorage.getItem("totalTransfer");

        if (saleTotal != null && saleTotal > 0) {
            value = Number(value) + Number(saleTotal);
        }
        if (otherSalesTotal != null && otherSalesTotal > 0) {
            value = Number(value) + Number(otherSalesTotal);
        }
        if (entryTotal != null && entryTotal > 0) {
            value = Number(value) + Number(entryTotal);
        }
        if (purchaseTotal != null && purchaseTotal > 0) {
            value = Number(value) - Number(purchaseTotal);
        }
        if (egressTotal != null && egressTotal > 0) {
            value = Number(value) - Number(egressTotal);
        }

        if (totalCommission != null && totalCommission > 0) {
            value = Number(value) + Number(totalCommission);
        }
        if (totalTransfer != null && totalTransfer > 0) {
            value = Number(value) - Number(totalTransfer);
        }

        setTotal(value);
        setDifference(Number(value) - Number(reportCash));
        setKeyTotal(keyTotal + 1);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (total != null || total != 0) {
            const date = new Date();
            var currentTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

            const newCashOut = {
                idUser: casher.id, idAdmin: localStorage.getItem("idUserSystem"), salesByMembershipTotal: localStorage.getItem("salesTotal"),
                otherSalesTotal: localStorage.getItem("otherSalesTotal"), entryTotal: localStorage.getItem("entryTotal"), egressTotal: localStorage.getItem("egressTotal"),
                purchaseTotal: localStorage.getItem("purchaseTotal"), total: total, difference: difference, cashReport: localStorage.getItem("reportCash"),
                creationDate: today, creationTime: currentTime, entryId: entryId, egressId: egressId, reportCashOutId: localStorage.getItem("reportCashId"),
                totalCash: Number(localStorage.getItem("totalCash")) - Number(localStorage.getItem("egressTotal")), totalVoucher: localStorage.getItem("totalVoucher"),
                totalCommission: localStorage.getItem("totalCommission"), totalTransfer: localStorage.getItem("totalTransfer")
            };

            const response = await fetch(baseUrl + "createCashOut", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newCashOut)
            });

            const json = await response.json();

            if (json.message == "Ok") {
                setCasher({ id: '', name: '', valid: null });
                setSales([]);
                setSalesAdditional([]);
                setEntry([]);
                setEgress([]);
                setPurchase([]);
                setSalesTotal(0);
                setSalesAdditionalTotal(0);
                setEntryTotal(0);
                setEgressTotal(0);
                setPurchaseTotal(0);
                setTotal(0);
                setReportCash(0);
                setTotalCash(0);
                setTotalVoucher(0);
                setTotalCommission(0);
                setTotalTransfer(0);
                setDifference(0);
                setEntryId([]);
                setEgressId([]);

                localStorage.removeItem("salesTotal");
                localStorage.removeItem("otherSalesTotal");
                localStorage.removeItem("entryTotal");
                localStorage.removeItem("egressTotal");
                localStorage.removeItem("reportCash");
                localStorage.removeItem("reportCashId");
                localStorage.removeItem("purchaseTotal");
                localStorage.removeItem("totalCommission");
                localStorage.removeItem("totalTransfer");
                localStorage.removeItem("totalVoucher");
                localStorage.removeItem("totalCash");
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    function currencyFormat(num) {
        return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    return (
        <>
            <ModalLoading
                isOpen={showModalLoading}
                closeModal={closeModalLoading}
            />
            <ModalMessageGeneric
                isOpen={showModalMessage}
                closeModal={closeModalMessage}
                message={"No hay fondo de caja inicial"}
            />

            <SnackbarMessage
                showSnackbar={showSnackbar}
                messageSnackbar={messageSnackbar}
                handleToClose={handleToClose}
                isError={errorSnackbar}
            />

            <div>
                {showModal ? (
                    <Modal
                        isOpen={showModal}
                        closeModal={closeModalLogin}
                    />
                ) : (
                    <></>
                )}
                <PageTitle title="Corte de caja" />

                <div className={classes.divHeader} >
                    <p className={classes.labelTitle}>{"Nombre: " + localStorage.getItem("name") ?? ""}</p>
                    <p className={classes.labelTitle}>{"Fecha: " + today}</p>
                </div>

                <div style={{ width: '40%', marginBottom: '40px' }}>
                    <div>
                        <div className={classes.divLabel}>
                            <p className={classes.label} >{"Cajero(a)"}</p>
                        </div>
                        <FormControl className={classes.formControl}>
                            <Select
                                onChange={handleChange}
                                displayEmpty
                                value={casher.id}
                                style={{ color: "#FFFFFF" }}
                            >
                                <MenuItem value=""> Selecciona </MenuItem>
                                {allCasher.map((option) => (
                                    <MenuItem value={option.id}>{option.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <div className={classes.divLabel}>
                            <p className={classes.label} >Turno</p>
                        </div>
                        <FormControl className={classes.formControl}>
                            <Select
                                onChange={handleChangeTurn}
                                displayEmpty
                                style={{ color: "#FFFFFF" }}
                            >
                                <MenuItem value=""> Selecciona </MenuItem>
                                {allTurns.map((option) => (
                                    <MenuItem value={option.value}>{option.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <Grid item xs={12}>
                    <Widget
                        noBodyPadding
                        bodyClass={classes.tableWidget}
                    >

                        <TableCell className={classes.tableRowStyleTitleCashOut} >Ventas por membresías</TableCell>
                        {sales.length == 0 ? (
                            <></>
                        ) : (
                            <div style={{ textAlign: "right" }}>
                                <Table className="mb-0" key={keyTableSales} style={{ marginBottom: "20px" }}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell size='small' style={{ textAlign: 'left', fontWeight: "600" }}>FECHA</TableCell>
                                            <TableCell size='small' padding='none' style={{ textAlign: 'left', fontWeight: "600" }}>FOLIO</TableCell>
                                            <TableCell size='small' padding='none' style={{ textAlign: 'center', fontWeight: "600" }}>SOCIO</TableCell>
                                            <TableCell size='small' padding='none' style={{ textAlign: 'center', fontWeight: "600" }}>MEMBRECÍA</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>IMPORTE</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sales.map(({ id, folio, partnerName, membershipName, total, date }) => (
                                            <TableRow>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ fontSize: "14px" }}>{date}</TableCell>
                                                <TableCell size='small' padding='none' className={classes.tableRowStyle} style={{ fontSize: "14px" }} >{folio}</TableCell>
                                                <TableCell size='small' padding='none' className={classes.tableRowStyle} style={{ fontSize: "14px" }} >{partnerName}</TableCell>
                                                <TableCell size='small' padding='none' className={classes.tableRowStyle} style={{ fontSize: "14px", textAlign: "center" }} >{membershipName}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyleTitle} style={{ textAlign: 'center', fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                                            </TableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                                <text className={classes.tableRowStyleSubTitleCashOut} >{"Total por membresías: " + currencyFormat(Number(salesTotal))} </text>
                            </div>
                        )}
                        <Divider />
                        <TableCell className={classes.tableRowStyleTitleCashOut} >Otras ventas</TableCell>
                        {salesAdditional.length == 0 ? (
                            <></>
                        ) : (
                            <>
                                <Table className="mb-0" key={keyTableSalesAdditional}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>PRODUCTO</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CANTIDAD</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>IMPORTE</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {salesAdditional.map(({ id, name, amount, total }) => (
                                            <TableRow>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }}>{name}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{amount}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyleTitle} style={{ textAlign: 'center', fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <p className={classes.tableRowStyleSubTitleCashOut} >{"Total por otras ventas: " + currencyFormat(Number(salesAdditionalTotal))} </p>
                            </>
                        )}
                        <Divider />
                        <TableCell className={classes.tableRowStyleTitleCashOut} >Otros ingresos</TableCell>
                        {entry.length == 0 ? (
                            <></>
                        ) : (
                            <>
                                <Table className="mb-0" key={keyTableEntry}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CONCEPTO</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CANTIDAD</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>IMPORTE</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {entry.map(({ id, name, amount, total }) => (
                                            <TableRow>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{name}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{amount}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <p className={classes.tableRowStyleSubTitleCashOut} >{"Total de otros ingresos: " + currencyFormat(Number(entryTotal))} </p>
                            </>
                        )}
                        <Divider />
                        <TableCell className={classes.tableRowStyleTitleCashOut} >Compras</TableCell>
                        {purchase.length == 0 ? (
                            <></>
                        ) : (
                            <>
                                <Table className="mb-0" key={keyTableEgress}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CONCEPTO</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>IMPORTE</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {purchase.map(({ name, total }) => (
                                            <TableRow>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{name}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <p className={classes.tableRowStyleSubTitleCashOut} >{"Total de compras: " + currencyFormat(Number(purchaseTotal))} </p>
                            </>
                        )}
                        <Divider />
                        <TableCell className={classes.tableRowStyleTitleCashOut} >Gastos</TableCell>
                        {egress.length == 0 ? (
                            <></>
                        ) : (
                            <>
                                <Table className="mb-0" key={keyTableEgress}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CONCEPTO</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>CANTIDAD</TableCell>
                                            <TableCell size='small' style={{ textAlign: 'center', fontWeight: "600" }}>IMPORTE</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {egress.map(({ id, name, amount, total }) => (
                                            <TableRow>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{name}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{amount}</TableCell>
                                                <TableCell size='small' className={classes.tableRowStyle} style={{ textAlign: 'center', fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <p className={classes.tableRowStyleSubTitleCashOut} >{"Total de gastos: " + currencyFormat(Number(egressTotal))} </p>
                            </>
                        )}
                        <Divider />
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Total</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(total))} </text>
                            </div>
                        </div>
                        <br />
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Reporte de caja</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(reportCash))} </text>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Total de efectivo</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(totalCash) - Number(egressTotal))} </text>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Total en vouchers</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(totalVoucher))} </text>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Total por comisiones</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(totalCommission))} </text>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Total por transferencias</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(totalTransfer))} </text>
                            </div>
                        </div>
                        <br /> <br /> <br />
                        <div style={{ display: 'flex', marginBottom: "30px" }}>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleTitleCashOutMarginLeft} >Diferencia</text>
                            </div>
                            <div className={classes.halfRow}>
                                <text className={classes.tableRowStyleSubTitleCashOutMarginTop} >{currencyFormat(Number(difference))} </text>
                            </div>
                        </div>
                    </Widget>
                </Grid>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <CircularProgress size={26} className={classes.loginLoader} />
                    ) : (
                        <button
                            className={total == null || total == 0
                                ? classes.disableButton : classes.enableButton}
                            disabled={(total == null || total == 0)}
                            onClick={onSubmit}
                        >Guardar</button>
                    )}
                </div>
            </div>
        </>
    );
}
